import { Store } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';
// Utils
import deepEqual from 'NewAngular/utils/equal/deep-equal';
import { getSecurityPageType } from 'NewAngular/utils/security-utils';
import { UtilsService } from 'NewAngular/services/core/utils.service';
// Constants
import { SAVED_ITEM_DROPDOWN_OPTIONS } from 'NewAngular/features/components/saved-items/constants/saved-item-dropdown.constants';
import { SAVED_SCATTER_PLOT_STATE_KEYS, SCATTER_PLOT_APP_STATE_SLICE_KEY, SCATTER_PLOT_SYSTEM_DEFAULT_STATE, } from 'ChartApp/ts/apps/scatter-plot/state/constants';
// Interfaces / Types / Enums
import { SavedItemDropdownAction } from 'NewAngular/features/components/saved-items/enums/saved-item-dropdown-action.enum';
import { SavedItemType } from 'NewAngular/features/components/saved-items/enums/saved-item-type.enum';
import { ToastMessageType } from 'NewAngular/features/components/toast-messages/toast-messages.enum';
// Services
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { SavedScatterPlotService } from 'NewAngular/features/components/saved-items/services/saved-scatter-plot.service';
import { ScatterPlotAppStateManager } from 'ChartApp/ts/apps/scatter-plot/services/scatter-plot-app-state-manager.service';
import { SelectedScatterPlotService } from 'ChartApp/ts/apps/scatter-plot/services/selected-scatter-plot.service';
import { PageToastMessagesService } from 'NewAngular/features/components/toast-messages/page-toast-messages-service';
// Components
import { TemplateModalComponent } from 'NewAngular/features/components/modals/template-modal/template-modal.component';
// Directives
import { FolderableSavedItemDropdownDirective } from 'FoldersApp/features/folders-shared/folderable-saved-item-dropdown/folderable-saved-item-dropdown.directive';
// NgRx
import { setDeserializedAppState } from 'NewAngular/state/app-state/app-state.actions';
import * as i0 from "@angular/core";
import * as i1 from "ChartApp/ts/apps/scatter-plot/services/scatter-plot-app-state-manager.service";
import * as i2 from "NewAngular/features/components/saved-items/services/saved-scatter-plot.service";
import * as i3 from "ChartApp/ts/apps/scatter-plot/services/selected-scatter-plot.service";
import * as i4 from "@ngrx/store";
import * as i5 from "NewAngular/features/components/toast-messages/page-toast-messages-service";
import * as i6 from "AccountsApp/ts/services/accounts.service";
import * as i7 from "NewAngular/services/core/utils.service";
import * as i8 from "FoldersApp/features/folders-shared/folderable-saved-item-dropdown/folderable-saved-item-dropdown.component";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/components/modals/template-modal/template-modal.component";
export class ScatterPlotSavedItemDropdownComponent extends FolderableSavedItemDropdownDirective {
    get itemIsEdited() {
        if (this.state === null || this.state.chartId === null)
            return false;
        if (this.prevState === null)
            return true;
        return SAVED_SCATTER_PLOT_STATE_KEYS.some((key) => {
            const defaultValue = SCATTER_PLOT_SYSTEM_DEFAULT_STATE[key] ?? '';
            const savedItemValue = this.prevState[key] || defaultValue;
            const currStateValue = this.state[key] || defaultValue;
            return !deepEqual(savedItemValue, currStateValue);
        });
    }
    constructor(appStateManager, savedItemService, selectedFolderableService, store, toastMessagesService, accountsService, utilsService) {
        super(appStateManager, savedItemService, selectedFolderableService, store, toastMessagesService);
        this.appStateManager = appStateManager;
        this.savedItemService = savedItemService;
        this.selectedFolderableService = selectedFolderableService;
        this.store = store;
        this.toastMessagesService = toastMessagesService;
        this.accountsService = accountsService;
        this.utilsService = utilsService;
        this.APP_STATE_SLICE_KEY = SCATTER_PLOT_APP_STATE_SLICE_KEY;
        this.ITEM_ID_SLICE_KEY = 'chartId';
        this.SAVED_SCATTER_PLOT_ITEM_TYPE = SavedItemType.SCATTER_PLOT;
        this.BASE_DROPDOWN_OPTIONS = SAVED_ITEM_DROPDOWN_OPTIONS;
    }
    ngOnInit() {
        super.ngOnInit();
        this.securityPageType = getSecurityPageType();
    }
    dropdownOperationHandler(operation) {
        switch (operation) {
            case SavedItemDropdownAction.NEW_FROM_TEMPLATE:
                this.templateModal.openModal();
                break;
            case SavedItemDropdownAction.SAVE:
                this.updateSavedItem();
                break;
            case SavedItemDropdownAction.SET_AS_DEFAULT:
                this.setAsDefault();
                break;
            case SavedItemDropdownAction.CLOSE:
                this.close();
                break;
            case SavedItemDropdownAction.COPY_STATE:
                this.copyStateToClipboard();
                break;
            default:
        }
    }
    selectTemplate(templateObject) {
        this.selectedFolderableService.clearSelection();
        this.store.dispatch(setDeserializedAppState({ deserializedAppState: templateObject.state }));
    }
    updateSavedItem() {
        if (this.state === null || this.state.chartId === null)
            return;
        this.savedItemService.updateItem(this.state.chartId, this.state).subscribe({
            next: () => {
                this.prevState = cloneDeep(this.state);
                this.toastMessagesService.addMessage(`Saved '${this.item?.name}'.`);
            },
            error: (errorResponse) => {
                this.toastMessagesService.addMessage(this.savedItemService.getErrorMessage(errorResponse), ToastMessageType.ERROR);
            },
        });
    }
    setAsDefault() {
        let params;
        if (this.securityPageType) {
            params = {
                [`default_${this.securityPageType}_scatter_plot`]: { ...this.state },
            };
        }
        else {
            params = { default_scatter_plot: { ...this.state } };
        }
        this.accountsService.putUserPreferences(params).subscribe();
    }
    copyStateToClipboard() {
        if (this.state === null)
            return;
        this.utilsService.copyStateDataToClipboard(this.state, SAVED_SCATTER_PLOT_STATE_KEYS, SCATTER_PLOT_SYSTEM_DEFAULT_STATE);
    }
}
ScatterPlotSavedItemDropdownComponent.ɵfac = function ScatterPlotSavedItemDropdownComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ScatterPlotSavedItemDropdownComponent)(i0.ɵɵdirectiveInject(i1.ScatterPlotAppStateManager), i0.ɵɵdirectiveInject(i2.SavedScatterPlotService), i0.ɵɵdirectiveInject(i3.SelectedScatterPlotService), i0.ɵɵdirectiveInject(i4.Store), i0.ɵɵdirectiveInject(i5.PageToastMessagesService), i0.ɵɵdirectiveInject(i6.AccountsService), i0.ɵɵdirectiveInject(i7.UtilsService)); };
ScatterPlotSavedItemDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ScatterPlotSavedItemDropdownComponent, selectors: [["ycn-scatter-plot-saved-item-dropdown"]], viewQuery: function ScatterPlotSavedItemDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(TemplateModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateModal = _t.first);
    } }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 8, consts: [[3, "dropdownOperation", "itemType", "itemTypeDescription", "defaultName", "ancestorFolderId", "itemIsEdited", "nameMaxLength", "dropdownOptions"], [3, "templateSelectionHandler", "itemType"]], template: function ScatterPlotSavedItemDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-folderable-saved-item-dropdown", 0);
        i0.ɵɵlistener("dropdownOperation", function ScatterPlotSavedItemDropdownComponent_Template_ycn_folderable_saved_item_dropdown_dropdownOperation_0_listener($event) { return ctx.dropdownOperationHandler($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "ycn-template-modal", 1);
        i0.ɵɵlistener("templateSelectionHandler", function ScatterPlotSavedItemDropdownComponent_Template_ycn_template_modal_templateSelectionHandler_1_listener($event) { return ctx.selectTemplate($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("itemType", "scatter_plot")("itemTypeDescription", "scatter plot")("defaultName", "New Scatter Plot")("ancestorFolderId", ctx.ancestorFolderId)("itemIsEdited", ctx.itemIsEdited)("nameMaxLength", 200)("dropdownOptions", ctx.dropdownOptions);
        i0.ɵɵadvance();
        i0.ɵɵproperty("itemType", ctx.SAVED_SCATTER_PLOT_ITEM_TYPE);
    } }, dependencies: [i8.FolderableSavedItemDropdownComponent, i9.TemplateModalComponent], encapsulation: 2 });
